import { Distrizone7Logo, Distrizone71, Distrizone72 } from "../assets/Distrizone7";
import { Pyrenees31Logo, Pyrenees31LP, Pyrenees312 } from "../assets/Pyrenees31";
import { MSCLogo, MSC1, MSC2 } from "../assets/MSC";
import {
  JoystiqueLogo,
  Joystique1,
  Joystique2,
  Joystique3,
  Joystique4,
  Joystique5,
  Joystique6,
} from "../assets/Joystique";
import {
  FoteliaLogo,
  Fotelia1,
  Fotelia2,
  Fotelia3,
  Fotelia4,
  Fotelia5,
  Fotelia6,
} from "../assets/Fotelia";
import {
  LevelLogo,
  Level1,
  Level2,
  Level3,
  Level4,
  Level5,
  Level6,
} from "../assets/Level";
import {
  GowheelsLogo,
  Gowheels1,
  Gowheels2,
  Gowheels3,
  Gowheels4,
  Gowheels5,
} from "../assets/Gowheels";
import {
  CaesarisLogo,
  Caesaris1,
  Caesaris2,
  Caesaris3,
} from "../assets/Caesaris";
import {
  AngelfripLogo,
  Angelfrip1,
  Angelfrip2,
  Angelfrip3,
} from "../assets/Angelfrip";

const projets = [
  {
    id: 1,
    title: "Distrizone 7",
    shortDescription:
      "Création d’un site e-commerce BtoB avec +30000 références",
    cover: Distrizone7Logo,
    images: [Distrizone71, Distrizone72],
    url: "https://distrizone7.com",
    technologies: ["WordPress", "PHP", "MySql", "ApiREST"],
    tools: ["Git", "Figma", "Postman"],
    description:
      "Conception et maquettage sur Figma à partir des souhaits donné par Distri Zone 7. Développement PHP - Wordpress / WooCommerce. Développement de 8 plug-ins sur mesure pour répondre à des besoins de fonctionnalités, de performance web et de coûts d’infrastructure. Modification du système de paiement par des crédits. Importateur custom de CSV/XML des références fournisseurs. Synchronisation des stocks avec les fournisseurs",
    role: "Développeur Full Stack",
    status: "Publié",
  },
  {
    id: 2,
    title: "Office de tourisme",
    shortDescription: "Création d’un CRM de gestion sur mesure",
    cover: Pyrenees31Logo,
    images: [Pyrenees31LP, Pyrenees312],
    url: "https://www.pyrenees31.com",
    technologies: [
      "JavaScript",
      "ReactJS",
      "TailwindCSS",
      "PostgreSQL",
      "ApiREST",
    ],
    tools: ["Git", "Figma", "Postman"],
    description:
      "1. Gestion des Disponibilités d’Hébergements : fonctionnalités principales : gestion des disponibilités pour les différents types d’hébergements (maisons d’hôtes, hôtels, gîtes), envoi quotidien d’e-mails aux hébergeurs pour vérifier si les disponibilités ont changé, espace dédié aux hébergeurs pour mettre à jour et gérer les informations concernant leurs hébergements, intégration automatique des hébergements disponibles sur le site web de l’office du tourisme, statistiques détaillées permettant à l’office du tourisme de suivre les tendances de disponibilité, les périodes de forte occupation, et les hébergeurs les plus actifs. 2. Gestion des Réclamations et Satisfaction Clients : fonctionnalités principales : système de gestion des réclamations reçues par l’office du tourisme, que ce soit par courrier ou par e-mail, suivi des réponses faites par les hébergeurs aux réclamations des clients, statistiques sur le traitement des réclamations, incluant le délai de réponse et la satisfaction des clients. Ce projet fournit une solution complète pour centraliser la gestion des hébergements et des réclamations, tout en optimisant la communication entre l’office du tourisme, les hébergeurs et les clients.",
    role: "Développeur Full Stack",
    status: "Publié",
  },
  {
    id: 3,
    title: "Mutuelle St-Christophe",
    shortDescription: "Refonte du tunnel de souscription auto",
    cover: MSCLogo,
    images: [MSC1, MSC2],
    url: "https://www.saint-christophe-assurances.fr/",
    technologies: [
      "JavaScript",
      "NextJS",
      "TailwindCSS",
      "ApiREST",
    ],
    tools: ["Jira", "Bitbucket"],
    description:
      "Intégration et gestion d’API pour l’obtention des données de tarification et de souscription en temps réel. Création et réalisation de tests unitaires via JEST. Gestion de projet en méthodologie Agile, gestion des tâches avec Jira, versionnage et gestion des pull requests via Bitbucket.",
    role: "Développeur Full Stack, spécialisé Front",
    status: "Publié",
  },
  {
    id: 4,
    title: "Joystique",
    shortDescription: "Création d'une plateforme de jeux vidéo communautaire",
    cover: JoystiqueLogo,
    images: [
      Joystique1,
      Joystique2,
      Joystique3,
      Joystique4,
      Joystique5,
      Joystique6,
    ],
    url: "https://joystique.fr/",
    technologies: [
      "JavaScript",
      "ReactJS",
      "PHP",
      "Symfony",
      "TailwindCSS",
      "API Platform",
      "MySql",
    ],
    tools: ["Trello", "Figma", "draw.io", "Postman", "Git"],
    description:
      "Joystique est une plateforme communautaire dédiée aux passionnés de jeux vidéo. Le projet vise à créer un espace où les utilisateurs peuvent partager leurs expériences, découvrir de nouveaux jeux, proposer des jeux à intégrer à la plateforme et plein d'autres fonctionnalités que j'ai imaginées, conçues et développées moi-même.",
    role: "Développeur Full Stack",
    status: "v1 publiée",
  },
  {
    id: 5,
    title: "Fotelia",
    shortDescription: "Création d'un site hôtelier de luxe",
    cover: FoteliaLogo,
    images: [Fotelia1, Fotelia2, Fotelia3, Fotelia4, Fotelia5, Fotelia6],
    url: "https://fotelia.abdel-mansouri.com/",
    technologies: ["JavaScript", "PHP", "Symfony", "Bootstrap", "MySql"],
    tools: ["Trello", "Figma", "Git"],
    description:
      "Fotelia est le site web d'un hôtel de luxe fictif situé à Paris, conçu pour permettre aux clients de réserver des chambres en ligne. Ce projet a été développé dans le cadre de ma formation sur Symfony, mettant l'accent sur la gestion des chambres, de la réservation à la vérification de leur disponibilité.",
    role: "Développeur Full Stack",
    status: "Publié",
  },
  {
    id: 6,
    title: "Level",
    shortDescription: "Développement d'un e-commerce de mode",
    cover: LevelLogo,
    images: [Level1, Level2, Level3, Level4, Level5, Level6],
    url: "https://level.abdel-mansouri.com/",
    technologies: ["Symfony", "Twig", "Bootstrap"],
    description:
      "Level est un site fictif de vente de vêtements en ligne, inspiré par United Colors of Benetton. Le projet, développé pendant ma formation Symfony, met en œuvre des fonctionnalités e-commerce complètes, de la gestion des produits au processus de commande.",
    role: "Développeur Full Stack",
    status: "Publié",
  },
  {
    id: 7,
    title: "GoWheels",
    shortDescription: "Conception d'une plateforme de location de véhicules",
    cover: GowheelsLogo,
    images: [Gowheels1, Gowheels2, Gowheels3, Gowheels4, Gowheels5],
    url: "https://gowheels.abdel-mansouri.com/",
    technologies: ["Symfony", "Twig", "Bootstrap"],
    description:
      "GoWheels est un projet fictif de location de voiture visant à offrir une expérience utilisateur élégante pour des marques telles que Chevrolet, Mercedes et Audi. Réalisé au cours de ma formation Symfony, il intègre des fonctionnalités de réservation et de gestion de flotte.",
    role: "Développeur Full Stack",
    status: "Publié",
  },
  {
    id: 8,
    title: "AngelFrip",
    shortDescription: "Site de réservation de produits d'occasion",
    cover: AngelfripLogo,
    images: [Angelfrip1, Angelfrip2, Angelfrip3],
    technologies: ["JavaScript", "ReactJS", "PHP", "Symfony", "TailwindCSS"],
    tools: ["Jira", "Figma", "Postman", "Git"],
    description:
      "AngelFrip est un projet conçu pour une auto-entrepreneuse spécialisée dans la vente de vêtements d'occasion via Facebook Live. Ce site vise à étendre sa présence en ligne en permettant la présentation et la réservation de ses produits sur une plateforme dédiée. En tant que développeur Full Stack avec une spécialisation en Front-end, j'ai pris en charge le développement de la page d'accueil, en assurant une expérience utilisateur fluide et réactive grâce à React et TailwindCSS. J'ai également implémenté une barre de recherche dynamique, permettant aux utilisateurs de trouver facilement des articles spécifiques. Ma contribution s'étend au-delà du front-end, ayant travaillé sur des aspects significatifs du back-end avec Symfony. Cela inclut la gestion des articles, l'implémentation de filtres avancés pour affiner les recherches, et la mise en place de la logique métier pour les réservations.",
    role: "Développeur Full Stack, spécialisé Front",
    status: "En cours de développement",
  },
  {
    id: 9,
    title: "Caesaris",
    shortDescription: "Développement d'une boutique de mode élégante",
    cover: CaesarisLogo,
    images: [Caesaris1, Caesaris2, Caesaris3],
    url: "https://caesaris.abdel-mansouri.com/",
    technologies: ["PHP", "HTML", "CSS"],
    description:
      "Caesaris est un site fictif de vente de vêtements en ligne, évoquant l'élégance de Ralph Lauren. Développé en PHP pur, ce projet m'a permis de mettre en pratique mes compétences en développement web en construisant ma première plateforme e-commerce.",
    role: "Développeur Full Stack",
    status: "Publié",
  },
];

export default projets;
